import { Spinner } from '../components/shared/Spinner';
import { Box } from '@bpba/ui-components';
import { Slider } from '../components/home/Slider';
import { Descripcion } from '../components/home/Descripcion';
import { Evento } from '../types/Evento';
import { Intro } from '../components/home/Intro';
import { HOME_EVENTOS } from '../components/shared/Constantes';

export const HomePage = () => {
  const eventos: Evento[] = HOME_EVENTOS;

  if (eventos.length === 0) return <Spinner />;

  return (
    <>
      <Intro marginTop={['25px']} marginBottom={['32px', '48px']} />
      <Box flexDirection={['column', 'column', 'column', 'row']}>
        <Box width={['100%', '100%', '100%', '55%', '60%']}>
          <Slider eventos={eventos} />
        </Box>
        <Box width={['100%', '100%', '100%', '45%', '40%']} marginTop={['25px', '48px']} marginLeft={['0px', null, null, '15px']}>
          <Descripcion />
        </Box>
      </Box>
    </>
  );
};
